import React from 'react';

export default function FeatureCard({ feature, dark = false }) {
  const Icon = feature.icon;
  if (dark) {
    return (
      <div data-testid="feature-card" className="relative rounded-2xl bg-gradient-to-b from-white/[0.05] to-white/[0.02] border border-white/10 p-6 backdrop-blur-xl lift-on-hover hover:border-white/25 overflow-hidden">
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[#0B172A] border border-white/10">
          <Icon className="h-5 w-5 text-[#22D3EE]" />
        </span>
        <h3 className="font-display mt-4 text-[16.5px] font-semibold tracking-[-0.02em] text-white">{feature.title}</h3>
        <p className="mt-2 text-[13.5px] text-slate-300/85 leading-relaxed">{feature.text}</p>
      </div>
    );
  }
  return (
    <div
      data-testid="feature-card"
      className="group relative rounded-2xl bg-white border border-slate-900/10 p-6 lift-on-hover hover:border-slate-900/15 shadow-[0_10px_30px_rgba(2,6,23,0.04)] hover:shadow-[0_22px_55px_rgba(2,6,23,0.10)] overflow-hidden"
    >
      <div
        className="absolute top-0 left-0 right-0 h-px opacity-60"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(37,99,235,0.45), rgba(34,211,238,0.45), transparent)' }}
        aria-hidden
      />
      <span
        className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-slate-900/10"
        style={{ background: 'linear-gradient(135deg, rgba(37,99,235,0.10), rgba(34,211,238,0.10) 55%, rgba(124,58,237,0.10))' }}
      >
        <Icon className="h-5 w-5 text-[#2563EB]" />
      </span>
      <h3 className="font-display mt-4 text-[16.5px] font-semibold tracking-[-0.02em] text-slate-900">{feature.title}</h3>
      <p className="mt-2 text-[14px] text-slate-600 leading-relaxed">{feature.text}</p>
    </div>
  );
}
